/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-props-no-spreading */
import { useCallback, useContext } from "react";

import { IPromiseProps } from "../components/PromisifiedDialog/PromisifiedDialog";
import { PromisifiedDialogContext } from "../context/PromisifiedDialogContext";

let uniqueCounter = 0;

function useCancellablePromisifiedDialog<ModalPropsT, ReturnedType = void>(
    PromisifiedDialog: React.ComponentType<
        IPromiseProps<ReturnedType> & ModalPropsT
    >
): (props: ModalPropsT) => [Promise<ReturnedType>, () => void] {
    const dialogContext = useContext(PromisifiedDialogContext);

    if (dialogContext === null) {
        throw new Error(
            "Seems like <PromisifiedDialog /> is not present in the tree above, wrap your app with it or check docs"
        );
    }

    return useCallback(
        (props: ModalPropsT): [Promise<ReturnedType>, () => void] => {
            const id = uniqueCounter++;

            let onResolve: (value: ReturnedType) => void;
            let onReject: (reason: any) => void;

            const promise = new Promise<ReturnedType>((resolve, reject) => {
                onResolve = (result: ReturnedType) => {
                    dialogContext.removeModal(id);

                    resolve(result);
                };

                onReject = (reason: any) => {
                    dialogContext.removeModal(id);

                    reject(reason);
                };
            });

            dialogContext.setModal(
                id,
                <PromisifiedDialog
                    onResolve={onResolve!}
                    onReject={onReject!}
                    {...props}
                />
            );

            const cancel = (): void => onReject("Closed from outside");

            return [promise, cancel];
        },
        [PromisifiedDialog]
    );
}

export { useCancellablePromisifiedDialog };
